<app-quota-summary-bar></app-quota-summary-bar>
<div class="page-container">
  <div class="page-header">
    <h1>{{ 'distributionQuotas.title' | translate }}</h1>
  </div>

  <!-- Tab bar -->
  <div class="tabs-row">
    <div class="tab-buttons">
      @for (tab of tabKeys; track tab.value) {
        <button
          class="tab-btn"
          [class.active]="activeTab() === tab.value"
          (click)="setActiveTab(tab.value)">
          {{ tab.labelKey | translate }}
        </button>
      }
    </div>
    @if (activeTab() !== 'all' && !isManager()) {
      <div class="action-buttons">
        <button mat-raised-button class="action-btn" (click)="distribute()">
          <mat-icon>shuffle</mat-icon>
          {{ 'distributionQuotas.distribute' | translate }}
        </button>
        <button mat-raised-button class="action-btn-secondary" (click)="changeStatusToRemainder()">
          <mat-icon>update</mat-icon>
          {{ 'distributionQuotas.changeStatusToRemainder' | translate }}
        </button>
      </div>
    }
  </div>

  @if (loading()) {
    <div class="loading-container">
      <mat-spinner diameter="50"></mat-spinner>
      <p>{{ 'distributionQuotas.loading' | translate }}</p>
    </div>
  } @else if (error()) {
    <div class="error-container">
      <mat-icon>error_outline</mat-icon>
      <p>{{ error() }}</p>
      <button mat-raised-button color="primary" (click)="loadQuotas()">
        {{ 'distributionQuotas.retry' | translate }}
      </button>
    </div>
  } @else {
    <div class="cards-grid">
      @for (quota of quotas(); track quota.id) {
        <div class="quota-card">
          <div class="card-header">
            <h3>{{ getMeatTypeName(quota.meatType) }}</h3>
          </div>

          <div class="card-content">
            <table class="quota-table">
              <thead>
                <tr>
                  <th>{{ 'distributionQuotas.supplierType' | translate }}</th>
                  <th class="number-cell">{{ 'distributionQuotas.totalLimit' | translate }}</th>
                  <th class="number-cell">{{ 'distributionQuotas.allocated' | translate }}</th>
                  <th class="number-cell">{{ 'distributionQuotas.remainder' | translate }}</th>
                </tr>
              </thead>
              <tbody>
                <!-- Main quota info -->
                <tr class="main-row">
                  <td>-</td>
                  <td class="number-cell">{{ quota.totalLimitVolume | kgToTons }}</td>
                  <td class="number-cell">{{ quota.allocatedVolume | kgToTons }}</td>
                  <td class="number-cell">{{ quota.remainderVolume | kgToTons }}</td>
                </tr>
                <!-- Supplier type limits -->
                @for (limit of quota.quotaSupplierTypeLimits; track limit.id) {
                  <tr>
                    <td class="supplier-type">{{ limit.supplierType | supplierType }}</td>
                    <td class="number-cell">{{ limit.totalLimitVolume | kgToTons }}</td>
                    <td class="number-cell">{{ limit.allocatedVolume | kgToTons }}</td>
                    <td class="number-cell">{{ limit.remainderVolume | kgToTons }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>

          <div class="card-footer">
            @if (activeTab() !== 'all') {
              <button mat-button (click)="downloadPdf(quota)">
                <mat-icon>picture_as_pdf</mat-icon>
                {{ 'distributionQuotas.downloadPdf' | translate }}
              </button>
              @if (!isManager()) {
                <button mat-button (click)="preview(quota)">
                  <mat-icon>preview</mat-icon>
                  {{ 'distributionQuotas.preview' | translate }}
                </button>
              }
            }
            <button mat-raised-button class="details-btn" (click)="viewDetails(quota)">
              {{ 'distributionQuotas.details' | translate }}
            </button>
          </div>
        </div>
      }
    </div>
  }
</div>
